import React, { useState } from "react";
import InfoSection from "../components/infoSection";
import Services from "../components/services";
import { Navbar } from "./../components/navbar";
import { Sidebar } from "./../components/sidebar";
import HeroSection from "../components/heroSection";
import Image1 from "../images/design-notes.svg";
import Image2 from "../images/space.svg";
import Footer from "../components/footer";
import "../App.css";

export const Home = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <Sidebar isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />
      <HeroSection></HeroSection>
      <InfoSection
        image={Image1}
        id="about"
        subtitle=""
        title="About ERXHoldings"
        text="At ERXHolding, our vision is clear and compelling: to enable AI for all. We believe that the transformative power of artificial intelligence should be accessible to everyone, from educational institutions, small businesses to large enterprises. Our mission is to empower organizations by providing cutting-edge generative AI solutions that drive innovation, efficiency, and growth."
        // btnText="Start today"
      />
      <InfoSection
        image={Image2}
        id="expertise"
        subtitle=""
        title="Our Expertise"
        text="ERXHolding specializes in developing bespoke generative AI solutions on cloud platforms (e.g., Amazon Web Services) tailored to meet the unique needs of our clients. Our team of experienced AI experts and data scientists work diligently to create sophisticated models that can generate content, automate processes, and provide deep insights, thereby transforming the way businesses operate."
        // btnText="Start today"
      />
      <Services></Services>
      <Footer />
    </>
  );
};

